import React from "react";
import {
  Stack,
  Heading,
  Text,
  RadioGroup,
  Radio,
  TextLink,
} from "@origin-digital/ods-core";
import { EICFormData } from "./types";
import LifeSupportAlert from "./LifeSupportAlert";

interface LifeSupportFieldsProps {
  values: EICFormData;
  errors: {
    lifeSupport?: string;
    whichEnergy?: string;
  };
  setFieldValue: (field: string, value: any) => void;
  hasElectricityAndGas: boolean;
}

const LifeSupportFields: React.FC<LifeSupportFieldsProps> = ({
  values,
  errors,
  setFieldValue,
  hasElectricityAndGas,
}) => {
  const onChangeLifeSupport = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFieldValue("lifeSupport", e.target.value);
    setFieldValue("whichEnergy", "");
  };

  return (
    <Stack space={["large", "xlarge"]}>
      <Heading variant="h4">Life support</Heading>
      <RadioGroup
        // @ts-expect-error: label is not a valid prop for RadioGroup
        label={
          <Text>
            Is anyone who lives (or plans to live) at the property on{" "}
            <TextLink
              href="https://www.origin.com.au/life-support"
              target="_blank"
            >
              life support?
            </TextLink>
          </Text>
        }
        name="lifeSupport"
        value={values.lifeSupport}
        onChange={onChangeLifeSupport}
        error={Boolean(errors.lifeSupport)}
        helperText={errors.lifeSupport || ""}
      >
        <Radio id="yes" label="Yes" value="yes" />
        <Radio id="no" label="No" value="no" />
      </RadioGroup>
      {hasElectricityAndGas && values.lifeSupport === "yes" && (
        <RadioGroup
          label="Which energy type runs the life support equipment?"
          name="whichEnergy"
          value={values.whichEnergy}
          onChange={(e) => setFieldValue("whichEnergy", e.target.value)}
          error={Boolean(errors.whichEnergy)}
          helperText={errors.whichEnergy || ""}
        >
          <Radio id="electricity" label="Electricity" value="electricity" />
          <Radio id="natural-gas" label="Natural gas" value="natural-gas" />
          <Radio id="both" label="Both" value="both" />
        </RadioGroup>
      )}
      {values.lifeSupport === "yes" && <LifeSupportAlert />}
    </Stack>
  );
};

export default LifeSupportFields;
